import { styled, TextField } from '@mui/material';

export const SearchField = styled(TextField)`
  .MuiInputBase-root {
    padding: 3px 11px !important;
    height: ${({ $height }: { $height?: string | number }) =>
      $height
        ? typeof $height === 'number'
          ? `${$height}px`
          : $height
        : '40px'};
  }

  input {
    font-size: 0.875rem;
    text-transform: none;

    &::placeholder {
      text-transform: none;
    }
  }

  fieldset {
    border-radius: 99px;
  }
`;
